@if (dialogData) {
  <section
    #modalContainer
    id="modal-container"
    class="flex flex-col bg-base-100 items-center theme-wrapper overflow-y-auto h-screen md:h-fit max-h-screen md:rounded-xl w-screen md:w-[400px] relative"
    (scroll)="onScroll($event)">
    <header class="sticky top-0 z-10 flex flex-col items-center w-full gap-3 pt-15 pb-6 px-6 md:p-6 theme-wrapper">
      <!-- Close Button -->
      <button class="absolute top-4 right-4 btn btn-ghost btn-sm btn-circle" (click)="onCancel()">
        <span class="icon-[mdi--close] text-xl text-base-content/60"></span>
      </button>
      <span [class]="iconClass()" [ngClass]="iconTypeClass()" class="text-4xl"></span>
      <h1 class="text-xl font-bold theme-text">
        {{ dialogData.title }}
      </h1>
    </header>

    @if (dialogData.data) {
      <div class="flex flex-col w-full gap-3 px-4 py-3 mb-6 border-base-content/10 border-y">
        @for (data of dialogData.data; track $index) {
          <div class="flex items-center justify-between">
            <span class="text-sm text-base-content/60">{{ data.key }}</span>
            <span class="text-sm">{{ data.value }}</span>
          </div>
        }
      </div>
    }

    @if (dialogData.inputs) {
      <div class="flex flex-col w-full gap-3 px-4 mb-6">
        @for (input of dialogData.inputs; track $index) {
          <lepi-fieldset>
            <lepi-label [required]="input.required || false">{{ input.label }}</lepi-label>
            @if (input.type !== 'textarea') {
              <input
                lepiInput
                [type]="input.type"
                [placeholder]="input.placeholder ?? ''"
                [value]="formValues()[input.key]"
                (input)="updateValue(input.key, $any($event.target).value)"
                class="w-full input focus-within:border-primary" />
            } @else {
              <textarea
                lepiInput
                (input)="updateValue(input.key, $any($event.target).value)"
                class="w-full textarea focus-within:border-primary resize-none"
                [placeholder]="input.placeholder ?? ''"
                [value]="formValues()[input.key]"></textarea>
            }
          </lepi-fieldset>
        }
      </div>
    }

    @if (dialogData.content) {
      <section class="flex items-center justify-center basis-full grow-0 md:basis-0">
        @if (!dialogData.markdown) {
          <div class="max-h-full px-4 text-center whitespace-pre-line text-pretty">
            {{ dialogData.content }}
          </div>
        } @else {
          <markdown class="px-4 basis-full grow-0" [data]="dialogData.content" />
        }
      </section>
    }

    @if (dialogData.checkbox) {
      <lepi-checkbox class="mt-6" [label]="dialogData.checkbox.text" [(checked)]="checked" />
    }

    <footer class="sticky bottom-0 z-10 flex w-full gap-3 p-4 mt-6 border-t theme-wrapper border-base-content/10">
      @if (!dialogData.buttons?.cancel?.hidden) {
        <button (click)="onCancel()" class="btn flex-1 btn-ghost">
          {{ dialogData.buttons?.cancel?.text ?? '취소' }}
        </button>
      }

      @if (dialogData.buttons?.confirm?.hidden !== true) {
        @let btnContent = dialogData.buttons?.confirm?.text ?? '확인';
        @let disabled = isFormInvalid() || checkInvalid();

        @switch (dialogData.type) {
          @case ('info') {
            <button [disabled]="disabled" class="btn flex-1 btn-primary" (click)="onConfirm()">
              {{ btnContent }}
            </button>
          }
          @case ('success') {
            <button [disabled]="disabled" class="btn flex-1 btn-success" (click)="onConfirm()">
              {{ btnContent }}
            </button>
          }
          @case ('warning') {
            <button [disabled]="disabled" class="btn flex-1 btn-warning" (click)="onConfirm()">
              {{ btnContent }}
            </button>
          }
          @case ('error') {
            <button [disabled]="disabled" class="btn flex-1 btn-error" (click)="onConfirm()">
              {{ btnContent }}
            </button>
          }
        }
      }
    </footer>
  </section>
}
